import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as HyundaiMenuNgrxActions from './hyundai-menu-ngrx.actions';
import * as HyundaiMenuNgrxFeature from './hyundai-menu-ngrx.reducer';
import * as HyundaiMenuNgrxSelectors from './hyundai-menu-ngrx.selectors';

@Injectable()
export class HyundaiMenuNgrxFacade {
  selectHyundaiServices$ = this.store.pipe(select(HyundaiMenuNgrxSelectors.getHyundaiServices));
  selectAcceptedServices$ = this.store.pipe(select(HyundaiMenuNgrxSelectors.getAcceptedServices));
  selectDeclinedServices$ = this.store.pipe(select(HyundaiMenuNgrxSelectors.getDeclinedServices));

  constructor(private readonly store: Store) {}

  updateServicesForHyundaiMenu(acceptedServices: any, declinedServices: any) {
    this.store.dispatch(
      HyundaiMenuNgrxActions.updateServicesForHyundaiMenu({
        acceptedServices,
        declinedServices,
      })
    );
  }

  acceptServiceForHyundaiMenu(acceptedService: any) {
    this.store.dispatch(
      HyundaiMenuNgrxActions.acceptServiceForHyundaiMenu({
        acceptedService,
      })
    );
  }

  declineServiceForHyundaiMenu(declinedService: any) {
    this.store.dispatch(
      HyundaiMenuNgrxActions.declineServiceForHyundaiMenu({
        declinedService,
      })
    );
  }

  removeAcceptedServiceFromHyundaiMenu(acceptedService: any) {
    this.store.dispatch(
      HyundaiMenuNgrxActions.removeAcceptedServiceFromHyundaiMenu({
        acceptedService,
      })
    );
  }

  removeDeclinedServiceFromHyundaiMenu(declinedService: any) {
    this.store.dispatch(
      HyundaiMenuNgrxActions.removeDeclinedServiceFromHyundaiMenu({
        declinedService,
      })
    );
  }

  init() {
    this.store.dispatch(HyundaiMenuNgrxActions.init());
  }
}
